module.exports = __webpack_public_path__ + "assets/img/show3.e26ec5c8.jpg";